import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { UserApi } from "../../../shared/sdk";
import { Funciones } from "../../../shared/funciones";

import * as _ from 'lodash';

@Component({
  selector: 'login-f-modal-page',
  templateUrl: './login-f-modal.component.html'
})
export class FrontLoginModalComponent implements OnInit {

  public invalidForm = false;
  public registerForm = false;
  public hideRecaptcha = false;
  public sending = false;
  public captchaValue: string;
  public invalidValues: any;

  public loginForm = this.fb.group({
    username: [null, [Validators.required]],
    password: [null, [Validators.required]],
    firstName: [null],
    lastName: [null],
    email: [null],
  });

  constructor(
    public activeModal: NgbActiveModal,
    public fb: FormBuilder,
    public funciones: Funciones,
    public userapi: UserApi
  ) { }

  ngOnInit() { }

  ingreso(e: any) {
    if (this.loginForm.valid) {
      if (this.registerForm) {
        if (this.captchaValue) {
          this.sending = true;
          const url = `${window.location.protocol}//${window.location.host}/profile/confirm-account/`;
          this.userapi.registerUser(
            this.loginForm.get('firstName').value,
            this.loginForm.get('lastName').value,
            this.loginForm.get('username').value,
            this.loginForm.get('password').value,
            this.loginForm.get('email').value,
            this.captchaValue,
            url,
          ).subscribe((res) => {
            if (!res.invalid) {
              this.activeModal.close('registered-user');
            } else if (res.invalid) {
              this.invalidValues = res.invalid;
              this.hideRecaptcha = true;
              this.invalidForm = false;
              this.captchaValue = '';
              this.sending = false;
              setTimeout(() => {
                this.hideRecaptcha = false;
              }, 20);
            }
          }, (err) => {
            this.activeModal.dismiss(err);
          });
        } else {
          this.invalidForm = true;
        }
      } else {
        this.sending = true;
        this.userapi.login(this.loginForm.value).subscribe(() => {
          window.localStorage.removeItem('prestamos-biblioteca');
          window.localStorage.removeItem('compras-libreria');
          this.activeModal.close();
        }, (err) => {
          this.activeModal.dismiss('invalid-user');
        });
      }
    } else {
      this.invalidForm = true;
    }
  }

  changeForm(value) {
    const fieldEmail = this.loginForm.get('email');
    const fieldPass = this.loginForm.get('password');
    const fieldFirstName = this.loginForm.get('firstName');
    const fieldlastName = this.loginForm.get('lastName');

    this.registerForm = value;

    if (value) {
      fieldEmail.setValidators([Validators.email]);
      fieldPass.setValidators([Validators.required, Validators.minLength(8)]);
      if (fieldFirstName) {
        fieldFirstName.setValidators([Validators.required]);
        fieldlastName.setValidators([Validators.required]);
      }
    } else {
      fieldEmail.clearValidators();
      fieldPass.setValidators([Validators.required]);
      if (fieldFirstName) {
        fieldFirstName.clearValidators();
        fieldlastName.clearValidators();
      }
    }
    fieldEmail.updateValueAndValidity();
    fieldPass.updateValueAndValidity();
  }

  resetPassword() {
    this.activeModal.dismiss('reset-password');
  }

  handleCorrectCaptcha(e) {
    this.captchaValue = e;
  }

}




// WEBPACK FOOTER //
// ./src/app/modules/frontend/login/login-f-modal.component.ts